import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Form } from 'react-bootstrap';
import actions from '../../redux/actions';
import Heading from '../Heading';
import NavButtons from '../NavButtons';
import CircumstancesPopup from './CircumstancesPopup';

class WorkType extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openModal: false,
    };
  }

  openModal(e) {
    e.preventDefault();
    this.setState({ openModal: true });
  }

  closeModal() {
    this.setState({ openModal: false });
  }

  handleWorkType(e, type) {
    e.preventDefault();

    this.props.assignAttribute('registeringTitle', null);
    if (type === 'single') {
      this.props.router.push('/copyright-reg/single-work-type/single');
    } else {
      this.props.router.push('/copyright-reg/multiple-work');
    }
  }

  render() {
    return (
      <div className="select-work work-type">
        <Heading text="How many works are you registering?" />

        <div className="content">
          <Form>
            <Row>
              <Col md={6} sm={12} className="type-view">
                <div
                  className="type-image"
                  onClick={(e) => this.handleWorkType(e, 'single')}
                >
                  <span>A Single Work</span>
                  <span>(one song, one image, one video, etc.)</span>
                </div>
              </Col>
              <Col md={6} sm={12} className="type-view">
                <div
                  className="type-image"
                  onClick={(e) => this.handleWorkType(e, 'multiple')}
                >
                  <span>Multiple Works</span>
                  <span>
                    (a group of works organized into an official collection,
                    like an album of music.)
                  </span>
                </div>
                <div className="circumstance-title">
                  Multiple works can be registered in{' '}
                  <a onClick={(e) => this.openModal(e)}>
                    certain circumstances
                  </a>
                </div>
              </Col>
            </Row>
          </Form>
          <CircumstancesPopup
            open={this.state.openModal}
            onClose={() => this.closeModal()}
          />
        </div>

        <div className="step-nav">
          <NavButtons
            direction="back"
            prev={() => this.props.router.push('/copyright-reg/copyright-type')}
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignCoregAttribute(field, attribute));
  },
});

export default connect(null, mapDispatchToProps)(WorkType);



// WEBPACK FOOTER //
// src/components/Copyright/WorkType.jsx